exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".GridRichTextEditor1 .grid{margin-left:0;border-top:1px solid #e6e6e6;padding-top:4rem}.GridRichTextEditor1 .grid .grid-item{margin-bottom:4rem;border-bottom:1px solid #e6e6e6;padding-bottom:4rem}@media (min-width:768px){.GridRichTextEditor1 .grid .grid-item:nth-child(odd)>div{border-right:1px solid #e6e6e6;padding-right:2.5rem}.GridRichTextEditor1 .grid .grid-item:nth-child(2n)>div{padding-left:2.5rem}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/sass-loader/lib/loader.js!./src/components/contents/GridRichTextEditor1/GridRichTextEditor1.s.scss
// module id = 964
// module chunks = 24